import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-production-details',
  templateUrl: './production-details.component.html',
  styleUrls: ['./production-details.component.css']
})
export class ProductionDetailsComponent implements OnInit {

  constructor(private productionService:ServiceService,private route: ActivatedRoute, private router: Router) { }

  ProductionId:any;
  output:any=[];
    //-------date formating-------------
  
    today: Date = new Date();
    pipe = new DatePipe('en-US');
    todayWithPipe:any= null;

    DateFormat(value:any){
    //-------date formating----------------------
    this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');
    return this.todayWithPipe
  
    }
  ngOnInit(): void {
    this.ProductionId=this.productionService.GetProductionId();
    this.productionService.GetProductionEach(this.ProductionId).subscribe((res)=>{
      this.output=res.data;
      console.log("res=",res);

      })
  }

}
